import Comment from "../../api/types/Comment";
import {v4 as uuid} from "uuid";
import PredefinedComment from "../../api/types/PredefinedComment";

export default function createComment(predefinedComment?: PredefinedComment): Comment {
    return {
        id: uuid(),
        comment: predefinedComment?.comment || '',
    }
};